import { Sprite, Texture, Container } from 'pixi.js';
import { SpineAnimation } from '@cc/pixi-app';
import { Player } from './Player';
import { moveType } from './../map/moveType';
import { avatarGenerator } from './AvatarGenerator';

const defaults = {
    skin: 'default',
    initAnim: 'idle',
    scale: 1,
    movement: {
        'walk': 1,
        'drive': 1,
        'swim': 1,
        'fly': 1
    },
    speed: 1,
    range: 1,
    keys: {
        up: "back",
        down: "front",
        right: "side",
        left: "side"
    }
};

export class Actor extends Container {
    constructor(id, data, offsetPos) {
        super();

        this.id = id;
        this.data = Object.assign({}, defaults, data);

        this.poses = new Map();
        Object.keys(this.data.turnarounds).forEach(key => {
            let anim;
            anim = avatarGenerator.getAnimation(this.data.turnarounds[key], this.data.keys[key], this.data.isAvatar);
            anim.setAnimation(0, this.data.initAnim, true);
            anim.setDefaultMix(0.2);
            anim.scale.set(this.data.scale);
            anim.position.set(offsetPos.x, offsetPos.y + 16);
            anim.visible = false;
            this.addChild(anim);
            this.poses.set(key.toUpperCase(), anim);
        });

        this.movementMap = new Map();
        Object.keys(this.data.movement).forEach(key => {
            this.movementMap.set(moveType[key], this.data.movement[key]);
        });

        this.currentDirection = Player.direction.down;
        this.currentPose = this.poses.get(this.currentDirection);
        this.currentPose.visible = true;
    }

    get speed() {
        return this.data.speed;
    }

    get range() {
        return this.data.range;
    }

    setDirection(direction) {
        var pose = this.poses.get(direction);

        if (pose !== this.currentPose) {
            pose.visible = true;
            this.currentPose.visible = false;
            this.currentPose = pose;
        }
    }

    idle() {
        this.currentPose.setAnimation(0, 'idle', true);
    }

    move() {
        this.currentPose.setAnimation(0, 'move', true);
    }

    celebrate() {
        if (this.currentPose !== this.poses.get(Player.direction.down)) {
            this.setDirection(Player.direction.down);
        }

        this.currentPose.setAnimation(0, 'celebrate', true);
    }
}
